import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CastleState {
  currentHealth: number;
  maxHealth: number;
  healthPercentage: number;
  defenseLevel: number;
  damageReduction: number;
  healthRegenRate: number;
}

const initialState: CastleState = {
  currentHealth: 1000,
  maxHealth: 1000,
  healthPercentage: 1,
  defenseLevel: 1,
  damageReduction: 0.1,
  healthRegenRate: 0
};

export const castleSlice = createSlice({
  name: 'castle',
  initialState,
  reducers: {
    updateCastleHealth: (state, action: PayloadAction<{
      currentHealth: number;
      maxHealth: number;
      healthPercentage: number;
    }>) => {
      state.currentHealth = action.payload.currentHealth;
      state.maxHealth = action.payload.maxHealth;
      state.healthPercentage = action.payload.healthPercentage;
    },
    
    updateDefenseLevel: (state, action: PayloadAction<{
      defenseLevel: number;
      damageReduction: number;
    }>) => {
      state.defenseLevel = action.payload.defenseLevel;
      state.damageReduction = action.payload.damageReduction;
    },
    
    updateHealthRegenRate: (state, action: PayloadAction<number>) => {
      state.healthRegenRate = action.payload;
    },
    
    resetCastleState: (state) => {
      return initialState;
    }
  }
});

export const {
  updateCastleHealth,
  updateDefenseLevel,
  updateHealthRegenRate,
  resetCastleState
} = castleSlice.actions;

export default castleSlice.reducer; 